<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">安全自查活动结果上报</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="活动状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.activityStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="检查对象">
          <el-select v-model="formInline.target_id" clearable filterable :placeholder="`请选择`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查人员">
          <el-select v-model="formInline.member_id" clearable filterable :loading="loading" remote
            :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="name" fixed label="活动名称" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="status_text" label="活动状态" width="150">
        </custom-table-column>
        <custom-table-column prop="target_name" label="检查对象" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="frequency_text" label="自查频率" width="100px">
        </custom-table-column>
        <custom-table-column prop="start_time" label="自查开始时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="end_time" label="自查结束时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="member_name" label="检查人员" width="200px">
        </custom-table-column>
        <custom-table-column prop="desc" label="活动描述" min-width="220px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="handleChildren(scope.row)" size="small">查看详情</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="结果上报" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="活动名称">
          <el-input v-model="ruleForm.name" placeholder="" disabled style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="自查频率">
          <el-select v-model="ruleForm.frequency" disabled  :placeholder="`请选择`">
            <el-option v-for="item in $store.state.frequencys" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自查开始时间" prop="start_time">
          <el-date-picker type="datetime" placeholder="请选择" disabled value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.start_time" style="width: 216px;" ></el-date-picker>
        </el-form-item>
        <el-form-item label="自查结束时间" prop="end_time">
          <el-date-picker type="datetime" placeholder="请选择" disabled value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.end_time" style="width: 216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="检查对象">
          <el-input v-model="ruleForm.target_name" placeholder="" disabled style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="检查人员">
          <el-input v-model="ruleForm.member_name" placeholder="" disabled style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="指标项">
          <el-input type="textarea" v-model="ruleForm.standards" disabled :rows="5" placeholder=""
            style="width:552px;"></el-input>
        </el-form-item> -->
        <el-form-item label="活动描述">
          <el-input type="textarea" v-model="ruleForm.desc" disabled :rows="5" placeholder=""
            style="width:552px;"></el-input>
        </el-form-item>
        <div class="add_win ">
          <p class="add_win_title">安全自查</p>
          <div class="add_win_body el-form">
            <el-form-item v-for="(item, index) in ruleForm.reports" :key="index"
              :label="`${(index + 1)}、${item.standard_name}`" :prop="`reports[${index}].standard_res`">
              <el-radio-group v-model="item.standard_res" style="width:532px;">
                <el-radio v-for="item in $store.state.zxjczt" :key="item.value" :label="item.value">{{ item.label
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="活动详情" :visible.sync="resultDialogVisible" width="946px">
      <div>
        <custom-table :data="tableData1" border style="width: 100%">
          <custom-table-column fixed label="序号" type="index" width="50">
          </custom-table-column>
          <custom-table-column prop="name" fixed label="活动名称" min-width="160px">
          </custom-table-column>
          <custom-table-column prop="status" label="活动状态" width="150" label-class-name="activityStatus"
            :formatter="format_arr">
          </custom-table-column>
          <custom-table-column prop="target_name" label="检查对象" min-width="160px">
          </custom-table-column>
          <custom-table-column prop="start_time" label="自查开始时间" width="160px">
          </custom-table-column>
          <custom-table-column prop="end_time" label="自查结束时间" width="160px">
          </custom-table-column>
          <custom-table-column prop="member_name" label="检查人员" width="200px">
          </custom-table-column>
          <custom-table-column prop="standards" label="指标项" min-width="340px">
            <template slot-scope="scope" v-if="scope.row.reports && scope.row.reports.length > 0">
              <p v-for="item in scope.row.reports">
                {{ item.standard_name }};
              </p>
            </template>
          </custom-table-column>
          <custom-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == 2" @click="handleDetail(scope.row)" type="text"
                size="small">查看结果</el-button>
              <el-button v-if="scope.row.status == 1" @click="handleEditNew(scope.row)" type="text"
                size="small">结果上报</el-button>
            </template>
          </custom-table-column>
        </custom-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resultDialogVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="deleteTarinRoom">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="查看结果" :visible.sync="detailDialogVisible" width="846px">
      <SafeSelfCheckRusult :rowObj="rowObj" />
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import SafeSelfCheckRusult from "./components/safeSelfCheckRusult";

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinFormatter],
  data() {
    return {
      formInline: {
        name: '',
        status: '',
        target_id: '',
        member_id: '',
      },
      formInline1: {
        id: ''
      },
      props: { multiple: true, value: 'name', label: 'value', emitPath: false },
      users: [],
      uploadType: 'image',
      detailDialogVisible: false,
      resultDialogVisible: false,
      tableData1: [],
      ruleForm: {
        name: '',
        start_time: '',
        end_time: '',
        frequency:'',
        target_name: '',
        member_name: '',
        desc: '',
        reports: [],
      },
      loading: false,
      rules: {},
      rowObj: {}
    };
  },
  components: {
    SafeSelfCheckRusult
  },
  created() {
    this.$store.dispatch('getTarinMent');
    
  },
  mounted() {
    this.setRules()
  },
  methods: {
    generateArrRules() {
      const arrRules = {};
      this.ruleForm.reports.forEach((item, index) => {
        arrRules[`reports[${index}].standard_res`] = [
          { required: true, message: `请选择`, trigger: 'change' }
        ];
      });
      return arrRules;
    },
    handleDetail(row) {
      this.detailDialogVisible = true
      this.rowObj = row
    }, 
    handleChildren(row) {
      this.formInline1.id = row.id
      this.tableData1 = []
      this.resultDialogVisible = true;
      this.handleQuery1()
    },
    handleQuery1() {
      this.$nextTick(() => {
        this.getList1();
      });
    },
    async getList1() {
      let res = await this.$api.instance.interfaceServer(`api/self-check-activity/sub-activities/${this.formInline1.id}`, 'get');
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data;
      }
    },
    setRules() {
      this.rules = {
        ...this.generateArrRules()
      };
    },
    handleEditNew(row, extraKeys = ['id']) {
      this.type = 'edit'
      this.title = "编辑"
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
      this.ruleForm = this.assignFormObj(this.ruleForm, row, extraKeys)
      this.ruleForm.activity_id = this.ruleForm.id
      if (this.ruleForm.reports && this.ruleForm.reports.length > 0) {
        this.ruleForm.reports = this.ruleForm.reports.map(item => {
          return {
            standard_res: item.standard_res,
            standard_name: item.standard_name,
          }
        })
      }
      // this.ruleForm.standards = row.reports? row.reports.map(item=>item.standard_name).join(";\n") : ''
      this.centerDialogVisible = true;
    },
    async remoteMethod(query, isConcat = false) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: 3
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        if (isConcat) {
          this.users = this.users.concat(res.data.data);
        } else {
          this.users = res.data.data;
        }
      }
      this.loading = false;

    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/self-check-activity/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      // console.log(params)
      // return
      let res = await this.$api.instance.interfaceServer(`api/self-check-activity/submit-report`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '上报成功！',
        });
        this.centerDialogVisible = false;
        this.getList1()
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.add_win_body {
  padding: 16px 24px;

  /deep/.el-form-item__label {
    width: 100% !important;
    text-align: left;
    line-height: 2;
  }

  /deep/.el-form-item__content {
    margin-left: 20px !important;
  }
}
</style>
